import {Fragment, useEffect, useState} from 'react'
import checkinApi from '../../../services/api/checkin/checkinApi'
import {Alert, Button, Grid, IconButton, Table, TableCell, TableHead, TableRow, TableBody, TableFooter, TablePagination, Skeleton} from '@mui/material'
import {getLocalDate} from '../../../utils/utilities'
import {ArrowDropDown, ArrowRight} from '@mui/icons-material'
import HeaderTableCell from '../../../components/common/StyledComponents/HeaderTableCell'
import StyledTableRow from '../../../components/common/StyledComponents/StyledTableRow'

const ROWS_PER_PAGE_OPTIONS = [10, 25, 50]

export default function PreviousCheckInList({id}) {
  const [list, setList] = useState([])
  const [loading, setLoading] = useState(false)
  const [loadFailed, setLoadFailed] = useState(false)
  const [selectedIds, setSelecteIds] = useState([])
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(ROWS_PER_PAGE_OPTIONS[0])

  const loadData = () => {
    setLoading(true)
    setLoadFailed(false)
    // A fresh list can be shorter than the one we were paging through.
    setPage(0)
    checkinApi
      .getList(id)
      .then(response => setList(Array.isArray(response) ? response : []))
      .catch(error => {
        // A failed fetch used to look exactly like "no previous check-ins".
        console.error('Failed to load previous check-in surveys', error)
        setList([])
        setLoadFailed(true)
      })
      .finally(() => setLoading(false))
  }
  useEffect(() => {
    loadData()
  }, [id])

  const isExpanded = l => selectedIds.indexOf(l.label) > -1

  const renderSubTable = l => {
    if (!isExpanded(l)) return ''
    return (
      <Table size='small'>
        <TableHead>
          <TableRow>
            <HeaderTableCell style={{backgroundColor: '#E84F6B',}}>Survey Name</HeaderTableCell>
            <HeaderTableCell style={{backgroundColor: '#E84F6B',}}>Start Date</HeaderTableCell>
            <HeaderTableCell style={{backgroundColor: '#E84F6B',}}>End Date</HeaderTableCell>
            <HeaderTableCell style={{backgroundColor: '#E84F6B',}}>Participation</HeaderTableCell>
          </TableRow>          
        </TableHead>
        <TableBody>
          {l.details?.map((r, index) => (
            <StyledTableRow key={`${l.label}-${index}`}>
              <TableCell>{`Survey ${index + 1}`}</TableCell>
              <TableCell>{getLocalDate(r.startDate)}</TableCell>
              <TableCell>{getLocalDate(r.endDate)}</TableCell>
              <TableCell>{r.participation}</TableCell>
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    )
  }

  if (loading)
  return (    
    <Grid container>
      <Grid item xs={12}>
        <>
          <Skeleton animation="wave" />
          <Skeleton animation="wave" />
          <Skeleton animation="wave" />            
        </>
      </Grid>
    </Grid>    
  )
    
  if (loadFailed)
    return (
      <Grid container>
        <Grid item xs={12}>
          <Alert
            severity="error"
            action={
              <Button color="inherit" size="small" onClick={loadData}>
                Retry
              </Button>
            }
          >
            We could not load the previous check-in surveys. Please try again.
          </Alert>
        </Grid>
      </Grid>
    )

  if (list.length === 0)
    return (
      <Grid container>
        <Grid item xs={12}>
          <Alert severity="info">No previous check-in surveys yet.</Alert>
        </Grid>
      </Grid>
    )

  // Only the cycles on the current page are rendered; the expanded cycles are
  // tracked by label, so a cycle stays open when the user pages back to it.
  const visibleCycles = list.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  )

  return (
      <Grid container mt={2}>
        <Grid item xs={12}>
          <div className="participation-breakdown">
            <Table size='small'>
              <TableHead>
                <TableRow>
                  <HeaderTableCell>Name</HeaderTableCell>
                  <HeaderTableCell>Start Date</HeaderTableCell>
                  <HeaderTableCell>End Date</HeaderTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {visibleCycles.map(l => (
                  <Fragment key={l.label}>
                    <StyledTableRow>
                      <TableCell>
                        <IconButton
                          disableRipple
                          aria-label={`${
                            isExpanded(l) ? 'Collapse' : 'Expand'
                          } ${l.label}`}
                          onClick={e => {
                            isExpanded(l)
                              ? setSelecteIds([
                                  ...selectedIds.filter(x => x !== l.label),
                                ])
                              : setSelecteIds([...selectedIds, l.label])
                          }}
                          sx={{padding: 0}}
                        >
                          {isExpanded(l) ? (
                            <ArrowDropDown></ArrowDropDown>
                          ) : (
                            <ArrowRight></ArrowRight>
                          )}
                        </IconButton>
                        {l.label}
                      </TableCell>
                      <TableCell>{getLocalDate(l.startDate)}</TableCell>
                      <TableCell>{getLocalDate(l.endDate)}</TableCell>
                    </StyledTableRow>

                    <tr>
                      <td colSpan={3}>{renderSubTable(l)}</td>
                    </tr>
                  </Fragment>
                ))}
              </TableBody>
              <TableFooter>
                <TableRow>
                  <TablePagination
                    colSpan={3}
                    count={list.length}
                    page={page}
                    rowsPerPage={rowsPerPage}
                    rowsPerPageOptions={ROWS_PER_PAGE_OPTIONS}
                    labelRowsPerPage="Check-ins per page"
                    onPageChange={(e, nextPage) => setPage(nextPage)}
                    onRowsPerPageChange={e => {
                      setRowsPerPage(parseInt(e.target.value, 10))
                      setPage(0)
                    }}
                  />
                </TableRow>
              </TableFooter>
            </Table>
          </div>          
        </Grid>
      </Grid>
    )
}
